import { Button, ActionIcon, Menu, Group, Tooltip, useMantineColorScheme } from "@mantine/core";
import { Settings, ChevronDown, Info, ExternalLink, Trash, Pencil } from "lucide-react";


export interface FormActionsButtonProps {
    setIsDetailsOpen: (open: boolean) => void;
    setIsDeleteModalOpen: (open: boolean) => void;
    onViewFullscreen: () => void;
    onViewSteps: () => void;
    onEdit: () => void;
}

export function FormActionsButton({
    setIsDetailsOpen,
    setIsDeleteModalOpen,
    onViewFullscreen,
    onViewSteps,
    onEdit,
}: FormActionsButtonProps) {
    const { colorScheme } = useMantineColorScheme();

    return (
        <Group gap="xs">
            <Menu shadow="md" width={200} position="bottom-end">
                <Menu.Target>
                    <Group gap={0}>
                        <Button
                            visibleFrom="sm"
                            color="black"
                            c="white"
                            leftSection={<Settings size={16} />}
                            rightSection={<ChevronDown size={14} />}
                        >
                            Actions
                        </Button>
                        <Tooltip label="Actions">
                            <ActionIcon
                                hiddenFrom="sm"
                                variant="filled"
                                color="black"
                                c="white"
                                size="lg"
                            >
                                <Settings size={20} />
                            </ActionIcon>
                        </Tooltip>
                    </Group>
                </Menu.Target>
                <Menu.Dropdown
                    style={{
                        backgroundColor: colorScheme === 'dark' ? 'var(--modal-bg)' : undefined,
                        borderColor: colorScheme === 'dark' ? 'var(--modal-border)' : undefined,
                        backdropFilter: 'blur(var(--modal-blur))'
                    }}
                >
                    <Menu.Item leftSection={<Info size={16} />} onClick={() => setIsDetailsOpen(true)}>View Details</Menu.Item>
                    <Menu.Item leftSection={<Pencil size={16} />} onClick={onEdit}>Edit</Menu.Item>
                    <Menu.Item 
                        leftSection={<ExternalLink size={16} />} 
                        onClick={onViewFullscreen}
                    >
                        View as Fullscreen
                    </Menu.Item>
                    <Menu.Item 
                        leftSection={<ExternalLink size={16} />} 
                        onClick={onViewSteps}
                    >
                        View as Steps
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item color="red" leftSection={<Trash size={16} />} onClick={() => setIsDeleteModalOpen(true)}>Delete</Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </Group >
    );
}
